import api from './api';

export const analyticsService = {
  // Get dashboard analytics
  getDashboard: async (params = {}) => {
    const response = await api.get('/analytics/dashboard', { params });
    return response.data;
  },

  // Get revenue trends
  getRevenueTrends: async (params = {}) => {
    const response = await api.get('/analytics/revenue-trend', { params });
    return response.data;
  },

  // Get supplier performance
  getSupplierPerformance: async (params = {}) => {
    const response = await api.get('/analytics/supplier-performance', { params });
    return response.data;
  },

  // Get quote conversion metrics
  getQuoteConversion: async (params = {}) => {
    const response = await api.get('/analytics/quote-conversion', { params });
    return response.data;
  },

  // Get client demographics
  getClientDemographics: async (params = {}) => {
    const response = await api.get('/analytics/client-demographics', { params });
    return response.data;
  },

  // Get agent performance
  getAgentPerformance: async (agentId, params = {}) => {
    const response = await api.get(`/analytics/agent/${agentId}/performance`, { params });
    return response.data;
  },

  // Get commission analytics
  getCommissionAnalytics: async (params = {}) => {
    const response = await api.get('/analytics/commissions', { params });
    return response.data;
  },

  // Get agency performance (admin only)
  getAgencyPerformance: async (params = {}) => {
    const response = await api.get('/analytics/agency-performance', { params });
    return response.data;
  }
};
